import { Button, Modal } from "@renderbus/ui";
import { useAuthManageStore } from "@/pages/authorization-management/store/auth-manage-store";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import styled from "styled-components";
import { statementList } from "@/pages/authorization-management/components/auth-statement-modal/constants/statement";
import { Checkbox } from "@renderbus/ui";
import { useState } from "react";
import { useCountDown } from "./hooks/useCountDown";

export function AuthStatementModal() {
  const {
    openAuthStatementDialog,
    setOpenAuthStatementDialog,
    setOpenEditAuthDrawer,
  } = useAuthManageStore();
  const [agree, setAgree] = useState(false);
  const t = getTranslateNsT("center");
  const { count } = useCountDown(5, openAuthStatementDialog);
  return (
    <Modal
      open={openAuthStatementDialog}
      width={"max-content"}
      children={
        <AuthStatementWrapper>
          <div className="title">{t("auth_manage_statement_title")}</div>
          <div className="tip">{t("user_auth_statement_title")}</div>
          <StatementContainer>
            {statementList.map((item) => {
              if (!item) return <br key={item} />;
              return <p key={item}>{item}</p>;
            })}
          </StatementContainer>
          <Footer>
            <Checkbox onChange={() => setAgree(!agree)} checked={agree}>
              {t("user_auth_statement_agree")}
            </Checkbox>
            <Button
              type="primary"
              disabled={!agree || Boolean(count)}
              onClick={() => {
                setOpenAuthStatementDialog(false);
                setOpenEditAuthDrawer(true);
              }}
            >
              {`${t("auth_manage_confirm_auth")}`}
              {count > 0 && <span>{`（${count}S）`}</span>}
            </Button>
          </Footer>
        </AuthStatementWrapper>
      }
      onCancel={() => setOpenAuthStatementDialog(false)}
      footer={null}
    />
  );
}

const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 40px;
  justify-content: space-between;
`;

const StatementContainer = styled.div`
  width: 672px;
  height: 565px;
  left: 0px;
  top: 0px;
  background: #262729;
  overflow: auto;
  white-space: pre-line;
  padding: 16px 24px 24px 24px;
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.85);
    margin: unset;
  }
`;

const AuthStatementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 14px;
  }
  .tip {
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #9ba2b0;
    margin-bottom: 19px;
  }
`;
